import React from "react";
import styled from "styled-components";
import { Col, Image } from "react-bootstrap";
import { FaCoffee } from "react-icons/fa";
import contactme_img from "../img/contact_me.jpg";
import LinkedInBadge from "./LinkedInBadge";

export default () => {
  return (
    <Styles>
      <Col sm={12} md={3} className="center-align">
        <Image src={contactme_img} type="jpg" fluid />
      </Col>
      <div className="divClass">
        <h6>
          Thank you for visiting my personal website. You may contact me through
          LinkedIn. Feel free to shoot me a message and let's connect{" "}
          <FaCoffee />
        </h6>
      </div>
      {/* LinkedIn*/}
      <Col>
        <LinkedInBadge />
      </Col>
    </Styles>
  );
};

const Styles = styled.div`
padding-top:7%;
min-height:90vh;

h1{
    text-align:center;
    margin-bottom:5%;
}

.center-align {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top:30px;
  width: 50%;
}

.divClass{
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
  text-align:center;
}


@media (min-width: 2200px) {
  h6 {
    font-size: 125%;
  }
  .img-fluid{
    vertical-align: middle;
    max-width:85% !important
  }
}

@media (max-width: 1024px) {
    padding-top:15%;
}

@media (max-width: 768px) {
    padding-top:15%;
    .img-fluid{
      max-width:150%;
      margin-left:-10%;
    }
}

@media (max-width: 576px) {
    min-height:96vh;
    padding-top:25%;
    .img-fluid{
      max-width:120%;
      margin-left:-10%;
    }
    .form-container{
        width:80%;
    }
    h6{
      font-size:80%
    }

`;
